/**
 * Copyright (c) SAGE3 Development Team 2024. All Rights Reserved
 * University of Hawaii, University of Illinois Chicago, Virginia Tech
 *
 * Distributed under the terms of the SAGE3 License.  The full license is in
 * the file LICENSE, distributed as part of this software.
 */

import { AppName } from './types';

// List of AI enabled apps
export const AI_ENABLED_APPS = [
  'Map',
  'Chat',
  'ImageViewer',
  'PDFViewer',
  'Stickie',
  'CodeEditor',
  'Webview',
  'Hawaii Mesonet',
] as AppName[];
